import { Selection, BaseType } from "d3-selection";
import { BarChartGroupItem, BarDataItem } from "./bar-chart";
import { BarChartSvgBars } from "./bar-chart-svg-bars";
import { Transition } from "d3-transition";
import { ScaleBand, ScaleLinear } from "d3-scale";

export class BarChartSvgDataGroup {
    selection: Selection<SVGGElement, BarChartGroupItem, BaseType, unknown>;
    constructor(selection) {
        this.selection = selection;
    }

    public updateBars(xScale, yScale, transitionDurationMs: number) {
        const bars = this.selection
            .selectAll<SVGGElement, BarChartGroupItem>(
                ".uic-bar-chart__bar-item"
            )
            .classed("uic-bar-chart__bar-item", true)
            .data<BarDataItem>((data: BarChartGroupItem) =>
                data.map((d) => ({ ...d, dataGroupKey: data.key }))
            );

        const enteringBars = bars
            .enter()
            .append("g")
            .classed("uic-bar-chart__bar-item", true);

        bars.exit().remove();

        enteringBars
            .append("rect")
            .call((s) => BarChartSvgDataGroup.positionBars(s, xScale, yScale));

        const existingBars = enteringBars.merge(bars);
        const barsRects = existingBars.select<SVGRectElement>("rect");

        barsRects
            .transition()
            .duration(transitionDurationMs)
            .call((s) => BarChartSvgDataGroup.positionBars(s, xScale, yScale));

        return new BarChartSvgBars(existingBars);
    }

    private static positionBars(
        selection:
            | Selection<SVGRectElement, BarDataItem, BaseType, unknown>
            | Transition<SVGRectElement, BarDataItem, BaseType, unknown>,
        xScale: ScaleBand<string>,
        yScale: ScaleLinear<number, number>
    ) {
        selection
            .attr("x", (d) => xScale(d.data.groupKey.toString()) || 0)
            .attr("y", (d) => yScale(d[1]))
            .attr("height", (d) => Math.max(0, yScale(d[0]) - yScale(d[1])))
            .attr("width", xScale.bandwidth());
    }
}
